import { SettingOutlined } from '@ant-design/icons'
import { Popconfirm, Popover } from 'antd'
import React, { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import TableBox from '../../../../Components/TableBox/TableBox'
import FilterLayout from '../../../../Layout/FilterLayout'
import TableLayout from '../../../../Layout/TableLayout'
import apiClient from '../../../../Util/apiClient'
import { GET_DATA, SET_DATA, validateAccess } from '../../../../Util/Util'
import POLPODFilter from './POLPODFilter'

export default function POLPOD() {
  const [POLPOD, setPOLPOD] = useState([])
  const history = useHistory()

  const getData = (params = {}) => {
    const filterCache = GET_DATA('POLPOD.filterData') || {}
    params = { ...filterCache, ...params }

    apiClient.get('pol-pod', { params }).then(({ status, data }) => {
      if (status === 200) {
        SET_DATA('POLPOD.filterData', { ...params, ...data.pageData })
        setPOLPOD(data.result)
      }
    })
  }

  useEffect(() => {
    getData()
  }, [])

  const onDelete = (id) => {
    apiClient.delete(`pol-pod/${id}`).then(({ status }) => {
      if (status === 204) {
        setPOLPOD(POLPOD.filter((item) => item.id !== id))
      }
    })
  }

  const tableActions = (row) => (
    <div className="action-buttons">
      <ul>
        {validateAccess('edit-pol-pod') && (
          <li>
            <Link to={`/app/edit-pol-pod/${row.id}`}>
              <i className="flaticon-edit-1" /> Edit
            </Link>
          </li>
        )}
        {validateAccess('edit-pol-pod') && (
          <li>
            <Popconfirm title="Sure to delete?" onConfirm={() => onDelete(row.id)}>
              <Link to="#">
                <i className="flaticon-delete-2" /> Delete
              </Link>
            </Popconfirm>
          </li>
        )}
      </ul>
    </div>
  )

  const columns = [
    {
      title: 'Code',
      dataIndex: 'code'
    },
    {
      title: 'Description',
      dataIndex: 'description'
    },
    {
      title: 'Status',
      dataIndex: 'status'
    },
    {
      title: 'Action',
      dataIndex: 'custom_action',
      render: (text, row) => (
        <Popover placement="bottomRight" content={tableActions(row)} trigger="click">
          <div className="btn-group">
            <button type="button" className="btn glow dropdown-toggle">
              <SettingOutlined /> <span className="caret" />
            </button>
          </div>
        </Popover>
      )
    }
  ]

  return (
    <FilterLayout
      addButton={{
        title: 'POL/POD',
        onClick: () => history.push('/app/add-pol-pod'),
        access: 'add-pol-pod'
      }}
      filterData={GET_DATA('POLPOD.filterData')}
      filter={<POLPODFilter onSubmit={getData} />}>
      <TableLayout title="POL/POD Overview" exportUrl="pol-pod/export">
        <TableBox
          dataSource={POLPOD}
          columns={columns}
          pageData={GET_DATA('POLPOD.filterData')}
          onChangePage={getData}
        />
      </TableLayout>
    </FilterLayout>
  )
}
